import type { DirectiveBinding } from "vue";

export default {
    beforeMount(element: HTMLElement, binding: DirectiveBinding<(event: MouseEvent) => void>) {
        element.clickOutsideEvent = (event?: MouseEvent) => {
            if(!event) return;
            const target = event.target as Node;
            if (element !== target && !element.contains(target)) {
                binding.value(event); 
            }
        };
        document.addEventListener("click", element.clickOutsideEvent);
    },
    unmounted(element: HTMLElement) {
        if(element.clickOutsideEvent) document.removeEventListener("click", element.clickOutsideEvent);
    },
};